import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {RuleConditionState, UiCondition} from '../../../modules/ruleengine/types';
import DeviceAndActionIcon from '../../common/DeviceAndActionIcon';
import {initConditionState} from '../ruleEditHelpers';
import {ACTION_TYPE_DEVICE} from '../../../modules/ruleengine/config/consts';
import TriggerCountDetails from './TriggerCountDetails';
import ElementTargetValues from './ElementTargetValues';
import './TriggerRuleCondition.less';
import TriggerDurationDetails from './TriggerDurationDetails';
type Props = {
	condition: UiCondition;
	onReset: (id: string) => void;
};

const TriggerRuleCondition = ({condition, onReset}: Props) => {
	const [augmentedCondition, setAugmentedCondition] = useState<RuleConditionState>({});
	useEffect(() => {
		initConditionState(condition).then(setAugmentedCondition);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const {asset, element, elementTarget} = augmentedCondition;
	const conditionClass = classNames({
		rule_condition_edit: true,
		valid: true,
		'trigger-rule': true
	});
	return (
		<div className={conditionClass} data-testid="trigger-rule-condition">
			<div className="condition-items">
				<div className="asset-identifier">
					<DeviceAndActionIcon asset={asset} type={ACTION_TYPE_DEVICE} />
					{asset ? (
						<Link to={`/assets/${asset.id}`} title={asset.name} data-testid="device-link">
							{asset.name}
						</Link>
					) : (
						''
					)}
				</div>
				<div className="element-target-identifier">
					&nbsp;
					{elementTarget && (
						<span data-testid="element-target-identifier">
							<Trans i18nKey={elementTarget.labelId}>{elementTarget.defaultLabel}</Trans>
						</span>
					)}
				</div>
				<div className="element-identifier">
					&nbsp;
					{element && (
						<span data-testid="element-identifier">
							(<Trans i18nKey={element.labelId}>{element.defaultLabel}</Trans>)
						</span>
					)}
				</div>
				<div className="element-target-value">
					{augmentedCondition && elementTarget && (
						<ElementTargetValues
							canEdit={false}
							elementTarget={elementTarget}
							currentConditionState={augmentedCondition}
							onChange={() => {
								//
							}}
						/>
					)}
				</div>
				<TriggerCountDetails condition={condition} onReset={onReset} />
				<TriggerDurationDetails condition={condition} />
			</div>
		</div>
	);
};

export default TriggerRuleCondition;
